import React from "react";
import {
    getItineraryDebugActionButtonStyle,
    getItineraryDebugToolbarContainerStyle,
    getItineraryDebugToolbarLabelStyle,
} from "./itineraryDebugToolbar.styles";

/** Props for the itinerary-details itinerary debug toolbar. */
export interface ItineraryDebugDetailsToolbarProps {
    "debugItineraries":               boolean;
    "isDarkUi":                       boolean;
    "isDisabled":                     boolean;
    "onRelaunchSegmentationAndOffer": () => void;
    "onRelaunchOffer":                () => void;
}

/**
 * Renders the debug toolbar for the itinerary details panel.
 *
 * @param props Toolbar visibility and action wiring.
 * @returns Debug toolbar content or null when inactive.
 */
export const ItineraryDebugDetailsToolbar: React.FC<ItineraryDebugDetailsToolbarProps> = ( {
    debugItineraries,
    isDarkUi,
    isDisabled,
    onRelaunchSegmentationAndOffer,
    onRelaunchOffer,
} ) => {
    if ( !__IS_DEV__ || !debugItineraries ) {
        return null;
    }

    return (
        <div style={getItineraryDebugToolbarContainerStyle( isDarkUi )}>
            <span style={getItineraryDebugToolbarLabelStyle( isDarkUi )}>
                Debug
            </span>
            <span
                className="inline-flex items-center font-semibold"
                onClick={isDisabled ? undefined : onRelaunchSegmentationAndOffer}
                style={getItineraryDebugActionButtonStyle( isDarkUi, isDisabled )}
            >
                Segmentation + offre
            </span>
            <span
                className="inline-flex items-center font-semibold"
                onClick={isDisabled ? undefined : onRelaunchOffer}
                style={getItineraryDebugActionButtonStyle( isDarkUi, isDisabled )}
            >
                Offre
            </span>
        </div>
    );
};
